<div [ngClass]="{ error: markError }" class="file-list-element flex flex-start-center gap-3">
  <span>{{ file.name }}</span>
  <button [disableRipple]="true" (click)="emitFileRemoval()" class="color-on-hover" color="warn" mat-icon-button>
    <mat-icon class="no-transition" svgIcon="close_tiny"></mat-icon>
  </button>
</div>
